import { store } from "src/store/store";
import environment from "src/utils/environment";
import { getEnabled, getSelectedSound, getDelay, getRepeat } from "src/modules/sound-alerts/duck/selectors";
import decodeOgg from "src/browser/decodeOgg";
import boldStart from "./boldStart.ogg";
import boldEnd from "./boldEnd.ogg";
import discreetStart from "./discreetStart.ogg";
import discreetEnd from "./discreetEnd.ogg";
import melodicStart from "./melodicStart.ogg";
import melodicEnd from "./melodicEnd.ogg";

const { isBrowser } = environment;

async function playSound(src) {
  const audio = new Audio();
  audio.onerror = async () => {
    if (!isBrowser) return;
    const response = await fetch(src);
    const arrayBuffer = await response.arrayBuffer();
    decodeOgg(audio, arrayBuffer);
  };
  audio.onended = () => audio.remove();
  audio.src = src;
  await audio.play();
}

export const SoundAlerts = {
  bold: {
    name: "bold",
    startSoundUrl: boldStart,
    endSoundUrl: boldEnd,
    playStartSound() {
      playSound(this.startSoundUrl);
    },
    playEndSound() {
      playSound(this.endSoundUrl);
    }
  },
  discreet: {
    name: "discreet",
    startSoundUrl: discreetStart,
    endSoundUrl: discreetEnd,
    playStartSound() {
      playSound(this.startSoundUrl);
    },
    playEndSound() {
      playSound(this.endSoundUrl);
    }
  },
  melodic: {
    name: "melodic",
    startSoundUrl: melodicStart,
    endSoundUrl: melodicEnd,
    playStartSound() {
      playSound(this.startSoundUrl);
    },
    playEndSound() {
      playSound(this.endSoundUrl);
    }
  }
};

const getSoundAlertState = () => {
  const state = store.getState();
  const alertsAreEnabled = getEnabled(state);
  const selectedSound = getSelectedSound(state);
  const repeat = getRepeat(state);
  const delay = getDelay(state);
  return { alertsAreEnabled, selectedSound, repeat, delay };
};

export function playStartSound() {
  const { alertsAreEnabled, selectedSound } = getSoundAlertState();
  if (!alertsAreEnabled) return;
  SoundAlerts[selectedSound].playStartSound();
}

export function playEndSound() {
  const { alertsAreEnabled, selectedSound } = getSoundAlertState();
  if (!alertsAreEnabled) return;
  SoundAlerts[selectedSound].playEndSound();
}

export class ControlledSoundAlerts {
  static isPlaying = false;
  static timeoutId = null;
  static repeatTime = 60000;
  static shouldPlayEndSound = false;

  static playStartSound = async () => {
    if (this.isPlaying) return;

    this.isPlaying = true;
    this.shouldPlayEndSound = true;

    const { delay, repeat } = getSoundAlertState();

    if (!delay && !repeat) playStartSound();
    if (!delay && repeat) this.startRepeatingStartSound();

    if (delay && !repeat) {
      await new Promise((r) => (this.timeoutId = setTimeout(r, delay)));
      playStartSound();
    }

    if (delay && repeat) {
      await new Promise((r) => (this.timeoutId = setTimeout(r, delay)));
      this.startRepeatingStartSound();
    }
  };

  static startRepeatingStartSound = () => {
    playStartSound();
    this.timeoutId = setTimeout(this.startRepeatingStartSound, this.repeatTime);
  };

  static playEndSound = () => {
    if (!this.shouldPlayEndSound) return;
    this.isPlaying = false;
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    playEndSound();
    this.shouldPlayEndSound = false;
  };
}
